import React from 'react';
import ReactDOM from 'react-dom/client';
import './prerenderPolyfills';
import './index.css';
import './styles/trimergy-design-system.css';
import './styles/trimergy-tokens.css'; // Tokens de la guía de marca 2026 (skill trimergy-brand)
import './styles/utilities.css'; // Utility classes para reducir inline styles
import AppRouter from './AppRouter';
import reportWebVitals from './reportWebVitals';
import { HelmetProvider } from 'react-helmet-async';
import { API_CONFIG } from './config/apiConfig';

// Función para mostrar login principal antes de React
function showMainAccessLogin() {
  document.body.innerHTML = `
    <div style="
      position: fixed;
      top: 0;
      left: 0;
      width: 100vw;
      height: 100vh;
      display: flex;
      align-items: center;
      justify-content: center;
      background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
      font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', sans-serif;
      margin: 0;
      z-index: 999999;
    ">
      <div style="
        background: white;
        padding: 40px;
        border-radius: 12px;
        box-shadow: 0 10px 40px rgba(0,0,0,0.2);
        width: 400px;
        max-width: 90vw;
      ">
        <h2 style="text-align: center; margin-bottom: 30px; color: #333; margin-top: 0;">
          🔐 Acceso al Entorno de Desarrollo
        </h2>
        
        <form id="mainLoginForm">
          <div style="margin-bottom: 20px;">
            <label style="display: block; margin-bottom: 8px; font-weight: 500;">
              Email:
            </label>
            <input
              type="email"
              id="emailInput"
              placeholder="usuario@ejemplo.com"
              style="
                width: 100%;
                padding: 12px;
                border: 1px solid #ddd;
                border-radius: 6px;
                fontSize: 16px;
                box-sizing: border-box;
              "
              required
            />
          </div>

          <div style="margin-bottom: 20px;">
            <label style="display: block; margin-bottom: 8px; font-weight: 500;">
              Password:
            </label>
            <input
              type="password"
              id="passwordInput"
              placeholder="contraseña"
              style="
                width: 100%;
                padding: 12px;
                border: 1px solid #ddd;
                border-radius: 6px;
                fontSize: 16px;
                box-sizing: border-box;
              "
              required
            />
          </div>

          <div id="errorMessage" style="
            background: #fee;
            color: #c53030;
            padding: 10px;
            border-radius: 6px;
            margin-bottom: 20px;
            text-align: center;
            display: none;
          "></div>

          <button
            type="submit"
            style="
              width: 100%;
              padding: 12px;
              background: #667eea;
              color: white;
              border: none;
              border-radius: 6px;
              fontSize: 16px;
              font-weight: 500;
              cursor: pointer;
            "
          >
            Acceder
          </button>
        </form>
      </div>
    </div>
  `;

  // Manejar el submit del formulario
  document.getElementById('mainLoginForm').addEventListener('submit', async function(e) {
    e.preventDefault();
    
    const email = document.getElementById('emailInput').value;
    const password = document.getElementById('passwordInput').value;
    const errorDiv = document.getElementById('errorMessage');
    
    // Validar credenciales contra el backend
    try {
      const response = await fetch(`${API_CONFIG.USER_API.BASE_URL}/api/auth/main-access`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ email, password }),
      });

      if (response.ok) {
        localStorage.setItem('mainAccessGranted', 'true');
        initializeReactApp();
      } else {
        errorDiv.textContent = 'Credenciales incorrectas';
        errorDiv.style.display = 'block';
      }
    } catch (error) {
      console.error('Error de conexión:', error);
      errorDiv.textContent = 'Error de conexión al servidor';
      errorDiv.style.display = 'block';
    }
  });
}

// Función para inicializar React
function initializeReactApp() {
  // Limpiar el body
  document.body.innerHTML = '<div id="root"></div>';

  const root = ReactDOM.createRoot(document.getElementById('root'));
  root.render(
    <React.StrictMode>
      <HelmetProvider>
        <AppRouter />
      </HelmetProvider>
    </React.StrictMode>
  );
}

// Verificar si ya se ha otorgado acceso principal
function checkMainAccess() {
  // TEMPORARILY DISABLED - Main access login
  // const hasAccess = localStorage.getItem('mainAccessGranted') === 'true';
  
  // Temporarily always grant access - skip main access verification
  const hasAccess = true;
  
  if (hasAccess) {
    // Tiene acceso, cargar React normalmente
    initializeReactApp();
  } else {
    // No tiene acceso, mostrar login
    showMainAccessLogin();
  }
}

// Ejecutar verificación
checkMainAccess();

// Añadir clase para garantizar scroll del navegador
document.body.classList.add('ensure-browser-scroll');

// If you want to start measuring performance in your app, pass a function
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
